module.exports = __webpack_public_path__ + "img/bulb-blue.4486eb04.png";